var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('h1',{staticClass:"font-semibold text-xl"},[_vm._v("Sales By History")]),_c('SalesHistory')],1)}
var staticRenderFns = []

export { render, staticRenderFns }